import { render, staticRenderFns } from "./BannerManager.vue?vue&type=template&id=0b50a3fc&scoped=true&"
import script from "./BannerManager.vue?vue&type=script&lang=js&"
export * from "./BannerManager.vue?vue&type=script&lang=js&"
import style0 from "./BannerManager.vue?vue&type=style&index=0&id=0b50a3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50a3fc",
  null
  
)

export default component.exports